export default {
  home_select_loan_amount: "選擇貸款金額",
  home_max_loan_amount: "最高額度",
  home_payment_amount: "付款金額",
  home_fullAppApplication: "全程app申請，免抵押",
  home_fullH5Application: "全程h5申請，免抵押",
  home_loan_amount: "借款額度",
  home_select_amount: "選擇額度",
  home_three_apply: "3分鐘內成功申請",
  home_loan_data_more_than: "借款期限超過120天",
  home_time_of_application: "申請時間",
  home_loan_period: "借款週期",
  home_repayment_amount: "還款金額",
  home_interest: "利息",
  home_service_charge: "服務費",
  home_privacy_policy: "我已閱讀並同意",
  home_login_privacy_policy: "登入並同意",
  home_login_hello: "你好",
  home_login_welcome: "歡迎來到",
  home_apply_for_loan: "申請貸款",
  home_get_quota_after_application: "申請後獲得配額",
  home_minute_review_minutes_funding: "5分鐘審核，10分鐘撥款",
  home_loan_application: "貸款申請",
  home_contact_us: "聯絡我們",
  home_contact_information: "聯絡方式",
  home_phone: "聯絡電話",
  home_free_consultation: "免費諮詢",
  home_address: "地址",
  home_dialog_title: "確認申請",
  home_dialog_msg: "是否確認提交貸款申請？",
  home_authentication: "認證",
  home_fill_information: "填入資料",
  home_toast_success: "申請成功",
  home_toast_withdraw_success: "領取成功",
  home_toast_err_1001: "您已發起貸款申請，請至訂單頁查看",
  home_toast_order_view: "已為您產生$1筆訂單，請查看",
  home_toast_no_new_order: "目前無新訂單生成，請完成在途訂單",
  home_toast_fail: "請先閱讀並同意",
  home_toast_fail_btn: "隱私權政策",
  home_onshow_toast_success: "已發送借款申請，請至訂單查看",
  home_cancel_btn: "取消",
  home_confirm_btn: "確定",
  home_transfer: "轉賬",
  home_credit_card: "信用卡",
  home_immediately_withdraw: "領取金額",
  home_back: "返回",
  home_unit_day: "天",
  home_Overdue_day: "已逾期",
  home_user: "使用者",
  home_success_loan: "成功借款",
  home_loan_amount_msg: "收到的金額和退款日期取決於最終結果",
  home_loan_limit: "貸款金額",
  home_click_line_account: "請點擊下方鏈接添加 LINE 賬號",
  home_service_fees_include: "服務費包含以下幾種費用",
  home_payment_fee: "支付費用",
  home_audit_consultation_fee: "審核諮詢費用",
  home_handling_fee: "手續費",
  home_successfulLoanToday: "今日已成功放款 XX 人",
  // LINE彈框相關
  line_popup_title: "登入成功!",
  line_popup_content: "為了更快完成您的申請,請立即添加我們的官方LINE,<br>即可享有優先審核與撥款、專人客服即時協助 ✨",
  line_popup_button: "立即加入LINE",
}